/** @jsx jsx */
import { Box, jsx } from 'theme-ui';
import { PopupButton, Widget, Sidetab, SliderButton } from '@typeform/embed-react';
import Button from './Button';

const typeToVariant = {
  'iso-sininen': 'primary',
  'iso-valkoinen': 'secondary',
  'pieni-sininen': 'small',
  'pieni-valkoinen': 'smallSecondary',
  'vain-teksti-sininen': 'plain',
  'vain-teksti-valkoinen': 'light',
};

export default ({ form, type, title, height, buttonType }) => {
  // example: "https://form.typeform.com/to/rhHJKvVM"
  const parts = (form || '').split('/');
  const formId = parts[parts.length - 1];

  if (!formId) return null;
  switch (type) {
    case 'popup button': {
      return (
        <PopupButton as="div" id={formId}>
          <Button variant={typeToVariant[buttonType] || 'primary'}>{title || 'avaa'}</Button>
        </PopupButton>
      );
    }
    case 'slider button': {
      return (
        <SliderButton as="div" id={formId}>
          <Button variant={typeToVariant[buttonType] || 'primary'}>{title || 'avaa'}</Button>
        </SliderButton>
      );
    }
    case 'sidetab': {
      return <Sidetab id={formId} buttonText={title || 'Avaa'} />;
    }
    case 'full page': {
      return (
        <Box
          sx={{
            width: ['calc(100vw - 32px)', , , 'calc(100vw - 64px)'],
            height: ['calc(100vh - 80px)', , , 'calc(100vh - 64px)'],
            maxWidth: '1312px',
            height: height ? 380 + 140 * height + 'px' : '500px',
          }}
        >
          <Widget id={formId} style={{ width: '100%', height: '100%' }} />
        </Box>
      );
    }
    case 'half page':
    default: {
      return (
        <Widget
          id={formId}
          style={{ height: '100%', minHeight: '50vh', height: height ? 380 + 140 * height + 'px' : '500px' }}
        />
      );
    }
  }
  /*
  return (
    <Fragment>
      <Script src="http://embed.typeform.com/next/embed.js" />
      <div data-tf-widget={formId} sx={inlineButton ? {} : { height: '100%', minHeight: '50vh' }} />}
    </Fragment>
  );
  // */
};
